var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',_vm._g(_vm._b({staticClass:"text-capitalize",attrs:{"dense":"","outlined":"","show-size":"","accept":_vm.fileType,"label":_vm.$t(_vm.label),"value":_vm.value,"rules":_vm.rules,"prepend-icon":_vm.icon},on:{"change":file => _vm.$emit('input', file)}},'v-file-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }